var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHXApp)?_c('div',{staticClass:"go-back-wrap",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../../../assets/images/go-back.png"),"alt":"返回"}}),_c('span',[_vm._v("返回")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }